import BigPopupTemplate from "components/templates/modal/big/BigPopupTemplate";
import React from "react";
import styled from "styled-components";
import { calcRem } from "styles/theme";

export default function ReleaseNote({
  onClickCancel,
  releaseNote,
}: {
  onClickCancel: () => void;
  releaseNote: string | null;
}) {
  if (!releaseNote) return null;
  return (
    <BigPopupTemplate title="Release Note" onModal={onClickCancel}>
      <ReleaseNoteWrapper
        dangerouslySetInnerHTML={{
          __html: (releaseNote || "")
            .replaceAll("color: #000000;", "")
            .replaceAll("color: #000;", ""),
        }}
      />
    </BigPopupTemplate>
  );
}

const ReleaseNoteWrapper = styled.div`
  color: ${({ theme }) => theme.COLORS.WHITE};
  font-size: ${calcRem(14)};
  line-height: 1.5;
  width: 100%;
`;
